import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_tenants_goods_received_list: { message: "idle" },
};

export const retrieve_tenants_goods_received_list_Slice = createSlice({
 name: "retrieve_tenants_goods_received_list",
 initialState,
 reducers: {
  success_retrieve_tenants_goods_received_list: (state, action) => {
   state.retrieve_tenants_goods_received_list = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_tenants_goods_received_list: (state, action) => {
   state.retrieve_tenants_goods_received_list = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_tenants_goods_received_list: (state) => {
   state.retrieve_tenants_goods_received_list = { status: app_consts.IDLE };
  },
  loading_retrieve_tenants_goods_received_list: (state) => {
   state.retrieve_tenants_goods_received_list = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_tenants_goods_received_list, fail_retrieve_tenants_goods_received_list, reset_retrieve_tenants_goods_received_list, loading_retrieve_tenants_goods_received_list } = retrieve_tenants_goods_received_list_Slice.actions;

export default retrieve_tenants_goods_received_list_Slice.reducer;